import {useSelector} from "react-redux";
import {
    BBDisableChildren,
    bbDoesCustomerHaveAccessToSubscriptionLevel, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf,
    bbGetSubscriptionLevelPropertyFromIdOrName,
    bbGetSubscriptionPropertyFromIdOrName,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import React from "react";
import {Box} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {HashLink as Link} from "react-router-hash-link";

//TODO: Make this work with portfolio by adding variable names for portfolio levels
//TODO: Sarah this function was inspired by your premium wrapper and may be easier to use in the long run
const DisableChildrenIfDoesntHaveAccessToSubscriptionLevel = ({
   children,

   // free = false,
    isActiveSubscriptionRequiredToUse = true,
   trial = false,
   lite = false,
   pro = false,
   premium = false,
    portfolioStarter = false,
    portfolioTrial = false,
    portfolioPro = false,
    portfolioPremium = false,
   overrideForAdminStaff = true,
    overrideForTrustedAgents = false,
   isCompact = false,
    isEntity = false,
    subscriptionNameOrId = "BRfB",
    allowHigherSubscriptions = true,
    showManageSubscriptionsButton = true,
    elementDisplayNameForConsoleLogs = "Unknown"
                                                                   })=>{


    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, entityInView} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customerIdToUse ? customers[customerIdToUse] : null : null;
    const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);



    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const applicableSubscriptionLevel = portfolioTrial
        ? "portfolioTrial"
        : portfolioStarter
            ? "portfolioStarter"
            : portfolioPro
                ? "portfolioPro"
                : portfolioPremium
                    ? "portfolioPremium"
                    : trial
                        ? "trial"
                        : lite
                            ? "lite"
                            : pro
                                ? "pro"
                                : premium
                                    ? "premium"
                                    : "free"

    const brSubscriptionRequired = bbGetSubscriptionLevelPropertyFromIdOrName(applicableSubscriptionLevel, "displayName");

    const applicableSubscriptionLevelId = bbGetSubscriptionLevelPropertyFromIdOrName(applicableSubscriptionLevel, "id");

    const applicableSubscriptionTypeId = bbGetSubscriptionPropertyFromIdOrName(subscriptionNameOrId, "id");

    const overrideEnabledForAdminsStaff = overrideForAdminStaff;
    //TODO: Also allow cases where customer only has a BRP subscription but wants to look at an entity.

    const overrideEnabledForTrustedAgents = overrideForTrustedAgents;

    const isCustomerSubscriptionPresent = customer && applicableSubscriptionLevelId && applicableSubscriptionTypeId ? bbDoesCustomerHaveAccessToSubscriptionLevel(customer, applicableSubscriptionTypeId, applicableSubscriptionLevelId, allowHigherSubscriptions) : null;
    // console.log("DisableIfDoesntHaveAccessToSubscriptionLevelWrapper for ","the element", elementDisplayNameForConsoleLogs, "customer", customer, "applicableSubscriptionLevel", applicableSubscriptionLevel, "applicableSubscriptionTypeId", applicableSubscriptionTypeId, "applicableSubscriptionLevelId", applicableSubscriptionLevelId, "isCustomerSubscriptionPresent", isCustomerSubscriptionPresent, "overrideForAdminStaff", overrideForAdminStaff, "isStaffAdmin", isStaffAdmin);



    //TODO: make sure this logic works for entity - if that is even desired
    const isCorrectSubscriptionLevel = isEntity
        ? myEntity && myEntity.active_subscription
            ? trial && (myEntity.trial_subscription || myEntity.lite_subscription || myEntity.premium_subscription || myEntity.pro_subscription)
                ? true
                    : lite && (myEntity.lite_subscription || myEntity.premium_subscription || myEntity.pro_subscription)
                ? true
                : pro && ( myEntity.premium_subscription || myEntity.pro_subscription)
                    ? true
                    : premium && (myEntity.premium_subscription)
            : null
        : customer && isCustomerSubscriptionPresent;


    const isModalBypassed = myEntity
    && brSubscriptionRequired
        ? ((overrideEnabledForAdminsStaff && isStaffAdmin) || (overrideEnabledForTrustedAgents && isTrustedAgentForThisEntity))
            ? true
            : isCorrectSubscriptionLevel
        : true

    // console.log("DisableIfDoesntHaveAccessToSubscriptionLevelWrapper","the element", elementDisplayNameForConsoleLogs, "customer", customer, "applicableSubscriptionLevel", applicableSubscriptionLevel, "applicableSubscriptionTypeId", applicableSubscriptionTypeId, "applicableSubscriptionLevelId", applicableSubscriptionLevelId, "isCustomerSubscriptionPresent", isCustomerSubscriptionPresent, "overrideForAdminStaff", overrideForAdminStaff, "isStaffAdmin", isStaffAdmin, "isEntity", isEntity, "brSubscriptionRequired", brSubscriptionRequired, "isCustomerSubscriptionPresent", isCustomerSubscriptionPresent, "isCorrectSubscriptionLevel", isCorrectSubscriptionLevel, "isModalBypassed", isModalBypassed)


    const manageSubscriptionButton = <span>
                                    <Button variant="contained" color="primary" style={{ marginBottom: 15}}>
                                        <Link smooth to={{pathname: "/board/settings/subscription"}} style={{color: "white"}}>Manage Subscriptions</Link>
                                    </Button>
                                </span>

    return(
        <Box className={"m-0 p-0"} style={{position: "relative", alignItems:"center"}}>

            <BBDisableChildren
                isDisabled={isActiveSubscriptionRequiredToUse ? isModalBypassed : true} //remember this flag is flipped!!!
                brSubscriptionRequired = {brSubscriptionRequired}
                isCompact = {isCompact}
                blurLevel={5}
                additionalComponent={showManageSubscriptionsButton ? manageSubscriptionButton : null}
            >
                {/*<div style={{right:"1%", top:"1%", position: "absolute", zIndex: 1}}>*/}
                {/*    <BBBreachRiskSubscriptionBadge subscriptionLevel={"Premium"} />*/}
                {/*</div>*/}
                {children}
            </BBDisableChildren>

        </Box>
    )
}

export default DisableChildrenIfDoesntHaveAccessToSubscriptionLevel;
